import React from 'react';
import { FaHeart, FaStore } from 'react-icons/fa';
import { MenuSection, SectionHeader, MenuItem, MenuItemIcon, MenuItemText} from '../Styles/AccountMenuStyles';

const MyActivity = () => {
  return (
    <MenuSection>
      <SectionHeader>My Activity</SectionHeader>
      <MenuItem>
        <MenuItemIcon>
          <FaHeart className="w-5 h-5 text-kuality-blue" />
        </MenuItemIcon>
        <MenuItemText>Wishlisted Products</MenuItemText>
      </MenuItem>
      <MenuItem>
        <MenuItemIcon>
          <FaStore className="w-5 h-5 text-kuality-blue" />
        </MenuItemIcon>
        <MenuItemText>Followed Shops</MenuItemText>
      </MenuItem>
    </MenuSection>
  );
};

export default MyActivity;